import { ApplicationEvent } from './application-event.model';
import {ApplicationEventType, PageNameTypes} from '../constants';

export class AlternativeProductsShowApplicationEventModel implements ApplicationEvent {

  type = ApplicationEventType.AlternativeProductsShow;

  constructor(private pageName: PageNameTypes) {
  }

  getPayload(): any {
    return {
      pageName: this.pageName
    };
  }
}
